<template>
    <div id="homePage">
        <div class="trade-wrap">
            <el-header @addUser="openAddUserDom" @editPass="openEditPassDom(null)"></el-header>
            <router-view></router-view>
        </div>
        <el-footer></el-footer>

        <transition-group name="fade">
            <!--修改密码-->
            <el-editPass @closeEditPass="openEditPassDom()" :key="Math.random() * 100"
                         v-if="showEditPass"></el-editPass>
            <!--增加账户-->
            <el-addUser @closeAddUser="openAddUserDom()" :key="Math.random() * 100"
                        v-if="showAddUser"></el-addUser>
        </transition-group>
    </div>
</template>

<script>
    import BaseHeader from "../HeaderMoudule/BaseHeader";
    import BaseFooter from "../FooterMoudule/BaseFooter";
    import HomePageEditPass from "../HeaderMoudule/BaseHeaderEditPass";
    import HomePageAddUser from "../HeaderMoudule/BaseHeaderAddUser";
    import UpdateGpList from "./HomeUpdateGpList";

    export default {
        name: "home",
        components: {
            'el-header': BaseHeader,
            'el-footer': BaseFooter,
            'el-editPass': HomePageEditPass,
            'el-addUser': HomePageAddUser,
        },
        sockets: {
            connect() {
                this.$socket.emit('login', 'client_' + this.$store.state.now_trade_account);
                this.sendApi();
            },
            disconnect() {
                // 断开了，重连、
                this.$socket.emit('reconnect', {reconnect: true});
            },
            reconnect(data) {
                this.$socket.emit('connect', 1);
            },
            /**
             * 监听socket数据的更新
             * @param data
             */
            new_msg(data) {
                const data_ = JSON.parse(data);
                console.log('接受推送', data_);
                if (data_.code === 1) {
                    const dataArr = data_.data instanceof Array ? data_.data : [data_.data];
                    this.$store.commit('UPDATE_GP_DETAIL', {data: dataArr});
                }
            }
        },
        mounted() {
            this.$socket.emit('connect', 1);
            this.tabId = this.$route.params.id;
            const that = this;
            // 判断socket状态，并重新连接
            this.socket_connected();
            let timehand_;
            window.addEventListener('resize', function () {
                if (timehand_) {
                    clearTimeout(timehand_)
                }
                timehand_ = setTimeout(() => {
                    that.$store.commit('HIDE_FOOTER', {
                        show: that.$store.state.hideFooter,
                        time: new Date().getTime()
                    });
                }, 300)
            }.bind(this))
        },
        computed: {
            token: function () {
                return this.$store.state.now_token;
            },
            userName: function () {
                return this.$store.state.now_trade_account;
            },
            isopen () {
                return this.$store.state.isopen;
            }
        },
        watch: {
            // 当切换账户的时候
            token: function (value) {
                if (value) {
                    this.getZixuanList();
                }
            },
            '$route'(to) {
                this.tabId = to.params.id;
            },
            isopen(v) {
                if(v) {
                    console.log('开始推送股票行情');
                    this.socket_connected();
                    this.sendApi();
                    this.getDapanList();
                }
            },
            // 当需要重新获取自选列表时
            '$store.state.upZixuan': function () {
                this.getZixuanList();
            },
            // 当需要socket推送的codes更新后，重新发起推送
            '$store.state.socket_codes': function (value) {
                if (value && value.length) {
                    this.sendApi();
                }
            },
            // 当需要socket推送的codes更新后，重新发起推送
            '$store.state.socket_codes2': function (value) {
                if (value && value.length) {
                    this.sendApi();
                }
            },
            // 当需要socket推送的codes更新后，重新发起推送
            '$store.state.socket_codes3': function (value) {
                if (value && value.length) {
                    this.sendApi();
                }
            }
        },
        methods: {
            // 每日更新股票列表
            ...UpdateGpList,
            openAddUserDom() {
                this.showAddUser = !this.showAddUser;
                if (this.showAddUser) {
                    this.showEditPass = false;
                }
            },
            openEditPassDom() {
                this.showEditPass = !this.showEditPass;
                if (this.showEditPass) {
                    this.showAddUser = false;
                }
            },
            // 推送请求
            sendApi() {
                // if (this.isopen) {
                    // 开市的状态，推送codes1 + codes2
                    const allCodes = this.$store.state.socket_codes.concat(this.$store.state.socket_codes2).concat(this.$store.state.socket_codes3);
                    this.$api.senUid(allCodes.join(','), 'client_' + this.$store.state.now_trade_account);
                // }
            },
            socket_connected() {
                if(this.isopen) {
                    if (!this.$socket.connected) {
                        this.$socket.emit('connect', 1);
                    }
                    setTimeout(() => {
                        // 断线重连，3秒执行一次
                        this.socket_connected();
                    }, 3000)
                }
            }
        },
        data: function () {
            return {
                showEditPass: false,
                showAddUser: false,
                bkNamess: ['gupiaolist_sz', 'gupiaolist_zx', 'gupiaolist_cy', 'gupiaolist_kc'],
                sendTimeout: null,
                tabId: 0
            }
        },
        created() {
            this.getDapanList();
            this.getAllGupiao();
            this.getZixuanList();
            this.$store.commit('SET_UID');
        }
    }
</script>

<style scoped>
    #homePage {
        width: 100vw;
        height: 100vh;
        overflow: hidden;
        background: #000000;
    }


</style>
